import { Components, Theme } from '@mui/material';
import { pickersSlideTransitionClasses } from '@mui/x-date-pickers-pro';

/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiDateCalendarOverrides to make it match the design system.
 *
 * See: https://mui.com/x/api/date-pickers/date-calendar/#classes
 */
export const MuiDateCalendar: Components<Theme>['MuiDateCalendar'] = {
  defaultProps: {
    dayOfWeekFormatter: (day) => day.slice(0, 2),
    showDaysOutsideCurrentMonth: true,
  },
  styleOverrides: {
    viewTransitionContainer: {
      // height needs to account for up to 6 calendar week rows
      [`.${pickersSlideTransitionClasses.root}`]: {
        minHeight: '200px',
      },
    },
  },
};
